import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const { honda_blue } = appPalette.colors;

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row-reverse',
    [theme.breakpoints.up('viewportMedium')]: {
      flexDirection: 'row',
    },
  },
  noChangeDealer: {
    [theme.breakpoints.up('viewportMedium')]: {
      flexDirection: 'row',
      marginTop: '2.1875rem',
    },
  },
  dealerTextButtonContainer: {
    justifyContent: 'space-between',
    width: 'auto',
    marginBottom: '1.5625rem',
    [theme.breakpoints.up('viewportMedium')]: {
      marginBottom: '0',
      marginTop: '1.5625rem',
    },
    ...(theme.themeName === 'honda' && {
      color: honda_blue,
    }),
  },
  dealerCTASvg: {
    height: '0.75rem !important',
    width: '0.5rem  !important',
    marginLeft: '0.3125rem',
    paddingTop: '0.0625rem',
  },
});
